var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgLogoMobile = function SvgLogoMobile(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 32,
    fill: "none",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F90000",
    d: "M2.1 16.9H0c.5 8 7.3 14.5 15.8 15V30c-7.4-.5-13.2-6.1-13.7-13.1M31.6 15h2.1C33.2 7 26.4.5 17.9 0v1.9C25.2 2.4 31.1 8 31.6 15M15.8 1.9V0C7.3.5.5 6.9 0 15h2.1C2.6 8 8.4 2.4 15.8 1.9M17.9 29.9v1.9c8.5-.5 15.3-6.9 15.8-15h-2.1c-.5 7.1-6.4 12.7-13.7 13.1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M24.9 7.4V5.2H14.2c-5.4 0-9.7 4.4-9.7 9.7v1.9c0 5.4 4.4 9.7 9.7 9.7h10.7v-2.2H14.2c-4 0-7.3-3.1-7.5-7.1v-.4H25v-2.2H6.7v-.4c.3-4 3.6-7.1 7.5-7.1h10.7z"
  })));
};
export default SvgLogoMobile;